<app-profile-menu></app-profile-menu>
<div class="content">
  <router-outlet></router-outlet>
</div>
